import './styles/CardControlButtons.scss';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Grid, Icon, ListItemIcon, MenuItem } from '@mui/material';

interface ButtonProps {
  index: number;
  handleDelete: Function;
  handleShowMore: Function;
  showMore: boolean;
  blockShowMore?: boolean;
  blockDeleteButton?: boolean;
  children?: React.ReactNode;
}

export function CardControlButtons({
  handleDelete,
  handleShowMore,
  showMore,
  blockShowMore = false,
  blockDeleteButton = false,
  children
}: ButtonProps) {
  return (
    <Grid container justifyContent="flex-end">
      {children}
      <Grid
        item
        className={`cardControlButtons__button__deactivated--${blockDeleteButton}`}
        onClick={() => {
          handleDelete();
        }}
      >
        <MenuItem className="cardControlButtons__container">
          <Grid className="cardControlButtons__container__icon" item xs={3}>
            <ListItemIcon>
              <Icon
                className={`far fa-trash-alt fa-sm cardControlButtons__container__icon__trashBlocked--${blockDeleteButton}`}
              />
            </ListItemIcon>
          </Grid>
        </MenuItem>
      </Grid>
      <Grid
        item
        className={`cardControlButtons__button__deactivated--${blockShowMore}`}
        onClick={() => {
          if (!blockShowMore) {
            handleShowMore();
          }
        }}
      >
        <MenuItem
          className={`cardControlButtons__container cardControlButtons__container__icon__showMoreBlocked--${blockShowMore}`}
        >
          <Grid className="cardControlButtons__container__icon" item xs={3}>
            <ListItemIcon>
              {showMore === true ? (
                <ExpandLess
                  style={{
                    width: 'auto',
                    fontSize: '1.8em'
                  }}
                />
              ) : (
                <ExpandMore
                  style={{
                    width: 'auto',
                    fontSize: '1.8em'
                  }}
                />
              )}
            </ListItemIcon>
          </Grid>
        </MenuItem>
      </Grid>
    </Grid>
  );
}
